module.exports = __webpack_public_path__ + "img/pic@2x.2ff3a22c.png";